import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  session: null,
  sessionStatus: '',
  sessionVerifying: false,
  customerPortalSession: null,
  subscription: null,
  subscriptionLoading: false,
  subcriptionUpdateReviewLoading: false,
  subcriptionUpdateReview: null,
};

const paymentsSlice = createSlice({
  name: 'paymentsSlice',
  initialState,
  reducers: {
    setSession: (state, { payload }) => {
      state.session = payload;
    },
    setSessionStatus: (state, { payload }) => {
      state.sessionStatus = payload;
    },
    setSessionVerifying: (state, { payload }) => {
      state.sessionVerifying = payload;
    },
    setCustomerPortalSession: (state, { payload }) => {
      state.customerPortalSession = payload;
    },
    setSubscription: (state, { payload }) => {
      state.subscription = payload;
    },
    setSubscriptionLoading: (state, { payload }) => {
      state.subscriptionLoading = payload;
    },
    setSubscriptionUpdateReviewLoading: (state, { payload }) => {
      state.subcriptionUpdateReviewLoading = payload;
    },
    setSubscriptionUpdateReview: (state, { payload }) => {
      state.subcriptionUpdateReview = payload;
    },
  },
});

const { actions, reducer } = paymentsSlice;

export const {
  setSession,
  setSessionStatus,
  setSessionVerifying,
  setCustomerPortalSession,
  setSubscription,
  setSubscriptionLoading,
  setSubscriptionUpdateReviewLoading,
  setSubscriptionUpdateReview,
} = actions;

export default reducer;
